import {setCareerScope} from 'app/Components/Page/CellcomCareersPage/Shared/Utils/Constants';

export const populationCitiesByCheckboxFilter = (listOfLocation, listCheckBox) => {
  const selectedCities = listOfLocation
    .filter((region) => listCheckBox.some((item) => item.id === region.reigon && item.checked))
    .flatMap((region) => region.cities.map((city) => city.name));
  console.log(selectedCities);
  return selectedCities;
};

const isNoneCheck = (listOfScope) => {
  const allChecked = listOfScope?.every((option) => !option.checked);

  return allChecked;
};
export const sortJobByIsHotJob = (listOfJob) => {
  if (Array.isArray(listOfJob)) {
    return [...listOfJob].sort((a, b) => (b.isHotAd ? 1 : -1));
  } else {
    // Handle the case where listOfJob is not an array
    return listOfJob;
  }
};
export const isEmptyFilter = (cities, utils, scope, filterJobData) => {
  if (utils?.length === 0 && cities?.length === 0 && scope?.length === 0) {
    return ['SHOW_ALL'];
  } else {
    return filterJobData;
  }
};

export const filterJobsByParams = (ads = [], util = '', cities = [], scope = []) => {
  if (util?.length === 0 && cities?.length === 0 && scope?.length === 0) {
    return ['SHOW_ALL'];
  }

  let result = ads || [];

  if (util.length > 0) {
    result = result.filter((job) => job.utilJobs === util);
    // result = result.length === 0 ? ads : result;
  }

  if (cities.length > 0) {
    result = result.filter((ad) => ad.listAdLocation.some((location) => cities.includes(location)));
  }

  if (scope.length > 0) {
    result = result.filter((job) => {
      return job.careerScope.some((s) => {
        return scope.includes(setCareerScope[s]);
      });
    });
  }

  return result;
};
